import { render, staticRenderFns } from "./SiiSyncWaitModal.vue?vue&type=template&id=8d63a56e&"
import script from "./SiiSyncWaitModal.vue?vue&type=script&lang=ts&"
export * from "./SiiSyncWaitModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports